/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import ValidatorTextField from "../../../Validator/ValidatorTextField";
import { moneyFieldDefault, requiredFieldDefault, textFieldDefault } from "../../../../services/validationRules";
import { processCostSupportStyle } from "../../processCostSupportStyle";
import { UseForm } from "../../../../types/UseForm";
import { BankAccount as BankAccountType } from "../../../../types/ProcessCostSupport";

type BankAccountProps = {
  path: string;
  account: BankAccountType;
  errors: UseForm["errors"];
  registerValidators: UseForm["registerValidators"];
  handleChange: UseForm["handleChange"];
};

const BankAccount = ({ path, account, errors, handleChange, registerValidators }: BankAccountProps) => {
  return (
    <>
      <Grid sx={processCostSupportStyle.question} size={12}>
        Bitte geben Sie hier weitere Details zu dem Konto an.
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <ValidatorTextField
          fullWidth={true}
          name={path + ".type"}
          label="Art des Kontos"
          margin="normal"
          value={account.type}
          registerValidators={registerValidators}
          validators={[...requiredFieldDefault, ...textFieldDefault]}
          error={!!errors[path + ".type"]}
          helperText={errors[path + ".type"] || "Bankkonto, Girokonto, Sparkonto etc."}
          onChange={handleChange}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <ValidatorTextField
          fullWidth={true}
          name={path + ".owner"}
          label="Kontoinhaber"
          margin="normal"
          value={account.owner}
          onChange={handleChange}
          registerValidators={registerValidators}
          validators={[...requiredFieldDefault, ...textFieldDefault]}
          error={!!errors[path + ".owner"]}
          helperText={errors[path + ".owner"]}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <ValidatorTextField
          fullWidth={true}
          name={path + ".name"}
          label="Kreditinstitut"
          margin="normal"
          value={account.name}
          onChange={handleChange}
          registerValidators={registerValidators}
          validators={[...requiredFieldDefault, ...textFieldDefault]}
          error={!!errors[path + ".name"]}
          helperText={
            errors[path + ".name"] || "Und ggf. Anteil des Kontos (falls Sie sich dieses z.B. mit Ihrem Partner teilen)"
          }
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
          lg: 4
        }}>
        <ValidatorTextField
          fullWidth={true}
          name={path + ".amount"}
          label="Aktueller Kontostand"
          margin="normal"
          value={account.amount}
          onChange={handleChange}
          registerValidators={registerValidators}
          validators={[...requiredFieldDefault, ...moneyFieldDefault]}
          error={!!errors[path + ".amount"]}
          helperText={
            errors[path + ".amount"] || "Genau dieser Kontostand muss mit einem aktuellen Kontoauszug belegt werden"
          }
        />
      </Grid>
    </>
  );
};

export default BankAccount;
